import { NgModule } from '@angular/core';

import { IconModule } from './../icon/icon.module';
import { IconHelpComponent } from './icon-help.component';

@NgModule({
  imports: [IconModule],
  declarations: [IconHelpComponent],
  exports: [IconHelpComponent],
})
export class IconHelpModule {}
export { IconHelpComponent } from './icon-help.component';
